import React from "react";
import { Reply } from "lucide-react";

/**
 * Reply to an interactive message (button_reply / list_reply / flow) or a
 * template quick-reply button. Both `interactive` and `button` Meta types route
 * here. Structured data: `message.metadata.interactive` or `message.metadata.button`.
 */
const InteractiveMessage = ({ message }) => {
  const i = message.metadata?.interactive || message.metadata?.button || {};
  const title = i.title || i.text || message.content || "Reply";
  const description = i.description || "";

  return (
    <div className="wa-msg__interactive">
      <span className="wa-msg__interactive-chip">
        <Reply size={11} /> {title}
      </span>
      {description && <span className="wa-msg__interactive-desc">{description}</span>}
    </div>
  );
};

export default InteractiveMessage;
